import { useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";

import { leaveBals } from "../../data";

import Select from "react-select";

const EmployeeFilterModal = ({
  user,
  data,
  details,
  setDetails,
  date,
  setDate,
  checked,
  handleCheckedChange,
  handleFilter,
  clearFilter,
}) => {
  const { filterBy } = useStateContext();

  const [empName, setEmpName] = useState([]);
  const [empEmail, setEmpEmail] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);

  const handleSelectChange = (e, type) => {
    // console.log(e.value);
    if (type === "empId") {
      setDetails((prev) => ({
        ...prev,
        empId: e.value,
      }));
    } else if (type === "email") {
      setDetails((prev) => ({
        ...prev,
        email: e.value,
      }));
    } else if (type === "location") {
      setDetails((prev) => ({
        ...prev,
        location: e.value,
      }));
    } else if (type === "leaveBalance") {
      setDetails((prev) => ({
        ...prev,
        leaveBalance: e.value,
      }));
    } else if (type === "designation") {
      setDetails((prev) => ({
        ...prev,
        designation: e.label,
      }));
    } else if (type === "department") {
      setDetails((prev) => ({
        ...prev,
        department: e.label,
      }));
    }
  };

  useEffect(() => {
    const empNames = data.map((item) => ({
      value: user.role === "2" ? item.empid : item.empId,
      label: item.name,
    }));
    const empEmails = data.map((item) => ({
      value: item.email,
      label: item.email,
    }));
    const uniqueDesignations = [
      ...new Set(data.map((item) => item.designation)),
    ].map((item) => ({
      value: item,
      label: item,
    }));
    const uniqueDepartments = [
      ...new Set(data.map((item) => item.department)),
    ].map((item) => ({
      value: item,
      label: item,
    }));

    const uniqueLocations = [...new Set(data.map((item) => item.location))].map(
      (item) => ({
        value: item,
        label: item,
      })
    );

    setLocations(uniqueLocations);

    setEmpName(empNames);
    setEmpEmail(empEmails);
    setDesignations(uniqueDesignations);
    setDepartments(uniqueDepartments);
  }, [data, user]);

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Employee Name/ID
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={empName}
                onChange={(e) => {
                  handleSelectChange(e, "empId");
                }}
                value={
                  Array.isArray(empName)
                    ? empName.filter((option) => option.value === details.empId)
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Email ID
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={empEmail}
                onChange={(e) => {
                  handleSelectChange(e, "email");
                }}
                value={
                  Array.isArray(empEmail)
                    ? empEmail.filter(
                        (option) => option.value === details.email
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Location
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={locations}
                onChange={(e) => {
                  handleSelectChange(e, "location");
                }}
                value={
                  Array.isArray(locations)
                    ? locations.filter(
                        (option) => option.value === details.location
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Department
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={departments}
                onChange={(e) => {
                  handleSelectChange(e, "department");
                }}
                value={
                  Array.isArray(departments)
                    ? departments.filter(
                        (option) => option.value === details.department
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Designation
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={designations}
                onChange={(e) => {
                  handleSelectChange(e, "designation");
                }}
                value={
                  Array.isArray(designations)
                    ? designations.filter(
                        (option) => option.value === details.designation
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Leave Balance
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={leaveBals}
                onChange={(e) => {
                  handleSelectChange(e, "leaveBalance");
                }}
                value={
                  Array.isArray(leaveBals)
                    ? leaveBals.filter(
                        (option) => option.value === details.leaveBalance
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <div className="statusFilter-flex2">
                <div className="sort-flex">
                  <div className="">
                    <img src={ProbationCircle} alt="" />
                    <span className="status-filter">Probation</span>
                  </div>
                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "1"}
                      onChange={handleCheckedChange("1")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <div className="">
                    <img src={FullTimeCircle} alt="" />
                    <span className="status-filter">Full Time</span>
                  </div>

                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "0"}
                      onChange={handleCheckedChange("0")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeFilterModal;
